import { createSelector } from '@ngrx/store';
import * as fromReprocessPaymentReducer from '../reducers';
import * as fromReprocessPayment from '../reducers/payment-reprocessor.reducer';

export const selectReprocessPayment = createSelector(
  fromReprocessPaymentReducer.selectReprocessPaymentState,
  fromReprocessPayment.selectReprocessPayment
);
export const selectReprocessPaymentIsLoaded = createSelector(
  fromReprocessPaymentReducer.selectReprocessPaymentState,
  fromReprocessPayment.selectReprocessPaymentLoaded
);
export const selectReprocessPaymentError = createSelector(
  fromReprocessPaymentReducer.selectReprocessPaymentState,
  fromReprocessPayment.selectReprocessPaymentError
);
